import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils.mjs';

function SvgIcSubdirectory(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7.125 2.125v7.813a2 2 0 0 0 2 2h10.75m0 0L16 8.062m3.875 3.876L16 15.812"
  }));
}
var IcSubdirectory = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSubdirectory));

export { IcSubdirectory as I };
